import React from 'react'
import styled from 'styled-components'
import GatsbyImage from 'gatsby-image'
import loadable from '@loadable/component'

const RichText = loadable(() => import('../RichText'))

const FaqContact = ({ contactBackground, contactText }) => {
  return (
    <StyledFaqContact>
      <StyledImage
        fluid={contactBackground.fluid}
        alt={contactBackground.title}
      />
      <Text>
        <RichText json={contactText}></RichText>
      </Text>
    </StyledFaqContact>
  )
}

const StyledFaqContact = styled.section`
  margin: ${(props) => props.theme.space.marginMobile}vw 0
    ${(props) => props.theme.space.marginMobile * 2}vw;
  height: 100vw;
  display: flex;
  align-items: center;
  position: relative;

  @media (min-width: ${(props) => props.theme.breakPoints.desktop}) {
    margin: ${(props) => props.theme.space.marginDesktop * 12}vw 0
      ${(props) => props.theme.space.marginDesktop * 8}vw;
    height: 60vw;
  }
`

const StyledImage = styled(GatsbyImage)`
  position: absolute !important;
  width: 100%;
  height: 100%;

  @media screen and (-ms-high-contrast: active) and (min-width: ${(props) =>
      props.theme.breakPoints.desktop}),
    screen and (-ms-high-contrast: none) and (min-width: ${(props) =>
      props.theme.breakPoints.desktop}) {
    top: 0;
    left: 0;
    bottom: 0;
  }
`
const Text = styled.div`
  font-size: 8vw;
  line-height: 9.3333333333vw;
  z-index: 2;
  color: white;
  padding: 0 ${(props) => props.theme.space.marginMobile * 2}vw;

  @media (min-width: ${(props) => props.theme.breakPoints.desktop}) {
    padding: 0 ${(props) => props.theme.space.marginDesktop * 16}vw;
    font-size: 6.25vw;
    line-height: 1;
  }

  a {
    color: #eabfbb !important;
    border-bottom: 0.8vw solid #eabfbb;
    line-height: 1;
    display: inline-block;

    @media (min-width: ${(props) => props.theme.breakPoints.desktop}) {
      border-bottom: 0;
      &::after {
        content: '';
        display: block;
        margin-top: 2px;
        height: 0.4vw;
        background: #eabfbb;
        transform: scaleX(0);
        transition: none;
        transform-origin: left;
      }
      &:hover::after {
        transform: scaleX(1);
        transition: transform 0.2s ease-out;
      }
    }
  }
`

export default FaqContact
